import { componentName, LoaderRadialClass } from './LoaderRadialClass';

customElements.define(componentName, LoaderRadialClass);

export { LoaderRadialClass, componentName };
